<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-12">
        <v-toolbar class="login-header" :class="{'test-mode': isTestBuild}" dark flat>
          <v-toolbar-title>Prijava <b v-if="isTestBuild" style="color: red;">- TEST</b></v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field @keydown.enter="signIn" v-model="form.username" label="Login" name="login" prepend-icon="mdi-account" type="text" />

            <v-text-field @keydown.enter="signIn" v-model="form.password" id="password" label="Password" name="password" prepend-icon="mdi-lock" type="password" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1">
            <v-checkbox
              color="#0F998E"
              class="remember-me"
              v-model="rememberMe"
              label="Zapomni si me"
            ></v-checkbox>
          </div>
          <v-btn @click="signIn" dark color="#0F998E">Prijavi se</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      form: {
        username: null,
        password: null
      },
      rememberMe: false
    }
  },
  computed: {
    ...mapGetters('companies', ['isDealer']),
    authRememberMe () {
      return !!this.$store.state.auth.rememberMe
    },
    isTestBuild () {
      return process.env.VUE_APP_MODE === 'test'
    }
  },
  methods: {
    ...mapActions('auth', ['signInWithEmailAndPassword', 'loadUser', 'updateRememberMe']),
    ...mapActions('companies', ['loadMyCompany']),
    ...mapActions('businessUnits', { loadBusinessUnits: 'loadItems', selectCurrentBusinessUnit: 'selectCurrent' }),
    loadRequiredData () {
      return new Promise((resolve, reject) => {
        const req = []
        if (this.$store.state.auth.userId && !this.$store.state.auth.user) {
          req.push(this.loadUser())
        }
        if (this.$store.state.auth.jwt) {
          req.push(this.loadMyCompany())
          req.push(this.loadBusinessUnits())
        }
        Promise.all(req)
          .then(() => {
            resolve()
          })
      })
    },
    signIn () {
      this.signInWithEmailAndPassword(this.form)
        .then(() => this.selectCurrentBusinessUnit(null))
        .then(() => this.loadRequiredData())
        .then(() => this.successRedirect())
    },
    successRedirect () {
      const homePage = this.isDealer ? { name: 'Home' } : { name: 'MyCompanyHome' }
      const redirectTo = this.$route.query.redirectTo || homePage
      this.$router.push(redirectTo)
    }
  },
  created () {
    this.rememberMe = this.authRememberMe
    this.$emit('ready')
  },
  watch: {
    rememberMe (rememberMe) {
      this.updateRememberMe(rememberMe)
    }
  }
}
</script>

<style lang="scss" scoped>
$hr-dark-green: #0F998E;
$hr-light-green: #6FC171;

.login-header {
  background-image: linear-gradient(to right, #464856 , #464856);
  &.test-mode {
    background-image: linear-gradient(to right, $hr-dark-green , $hr-light-green);
  }
}
.remember-me {
  margin: 0px;
  padding-left: 10px;
  height: 30px;
}
</style>
